import React from 'react';
import EmailLink from '../../Comp/EmailLink';

const faqs = [
  {
    category: '📱 About App',
    items: [
      {
        question: '1. What can I do with Page Bloom?',
        answer:
          'Page Bloom helps you read PDFs, convert files to PDF, scan documents, merge files, compress PDFs, lock documents, and manage all your files in one place.',
      },
      {
        question: '2. Does the app work without the internet?',
        answer:
          'Yes, most features like PDF reading, editing, scanning, and file management work offline.',
      },
      {
        question: '3. Why does the app need storage permission?',
        answer:
          'Storage access helps Page Bloom find, open, organize, and manage your PDF and document files smoothly.',
      },
      {
        question: '4. Why are some files opening slowly?',
        answer:
          'Large files or low storage space can affect speed. Cleaning junk files and freeing up storage may improve performance.',
      },
      {
        question: '5. How do I make Page Bloom my default PDF reader?',
        answer:
          'Open any PDF file, choose Page Bloom from the options, and tap “Always” to set it as the default reader.',
      },
    ],
  },
  {
    category: '🔄 PDF Conversion Tools',
    items: [
      {
        question: '6. How does the Image to PDF feature work?',
        answer:
          'Select photos from your gallery, arrange them if needed, and convert them into a single PDF in seconds.',
      },
      {
        question: '7. Can I turn Word files into PDFs?',
        answer:
          'Yes, the Word to PDF tool quickly converts DOC or DOCX files into easy-to-share PDF documents.',
      },
      {
        question: '8. What is the Scan to PDF feature used for?',
        answer:
          'It lets you scan notes, receipts, IDs, or documents using your camera and save them as PDFs instantly.',
      },
      {
        question: '9. Can I convert documents into PDF format easily?',
        answer:
          'Yes, the Doc to PDF feature helps convert supported documents into high-quality PDF files quickly.',
      },
      {
        question: '10. Will the converted PDF keep the original quality?',
        answer:
          'Yes, Page Bloom keeps text and images clear while converting files into PDF format.',
      },
    ],
  },
  {
    category: '✏️ PDF Editing and Management',
    items: [
      {
        question: '11. How can I merge multiple PDFs into one file?',
        answer:
          'Choose the Merge PDF tool, select your files, and combine them into one organized document.',
      },
      {
        question: '12. Can I split pages from a PDF?',
        answer:
          'Yes, the Split PDF feature allows you to remove or separate specific pages easily.',
      },
      {
        question: '13. How do I compress a PDF file?',
        answer:
          'Use the Compress PDF tool to reduce file size while keeping the document readable and shareable.',
      },
      {
        question: '14. Can I add my signature to a PDF?',
        answer:
          'Yes, the Sign feature allows you to create and add digital signatures directly to your documents.',
      },
      {
        question: '15. How do I lock a PDF file?',
        answer:
          'You can protect important documents with a password using the Lock PDF feature.',
      },
    ],
  },
  {
    category: '👁️ PDF Viewing and Sharing',
    items: [
      {
        question: '16. How can I read PDFs more comfortably?',
        answer:
          'Use zoom controls and smooth scrolling for an easier reading experience.',
      },
      {
        question: '17. Can I print PDF files directly from Page Bloom?',
        answer:
          'Yes, the Print PDF feature lets you print documents quickly using a connected printer.',
      },
      {
        question: '18. How do I share PDF files?',
        answer:
          'Open the file and tap the share option to send PDFs through email, messaging apps, or other platforms.',
      },
      {
        question: '19. How does the Extract Text feature work?',
        answer:
          'The Extract Text tool in Page Bloom scans your PDF or image files and quickly converts visible text into editable and copyable text.',
      },
    ],
  },
  {
    category: '🔒 File Safety and Storage',
    items: [
      {
        question: '20. Are my files safe in the app?',
        answer:
          'Yes, your files stay stored on your device and can be protected using password lock features.',
      },
      {
        question: '21. Can I manage all my files in one place?',
        answer:
          'Yes, the built-in file manager helps you organize, rename, delete, and access files easily.',
      },
      {
        question: '22. Can the app handle large PDF documents?',
        answer:
          'Yes, Page Bloom is optimized for smooth performance even with large files.',
      },
    ],
  },
];

const PDFReaderFAQs = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Page Bloom PDF Reader FAQs</h1>
      <p className="mb-6">
        If you have any queries for our Page Bloom PDF Reader app or face any difficulty using it, please write to us at{' '}
        <EmailLink />.
      </p>
      {faqs.map((section, idx) => (
        <div key={idx} className="mb-8">
          <h2 className="text-xl font-semibold mb-3">{section.category}</h2>
          <ul className="space-y-4">
            {section.items.map((item, i) => (
              <li key={i}>
                <p className="font-bold">{item.question}</p>
                <div className="text-gray-700">{item.answer}</div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default PDFReaderFAQs;
